import React, { Component } from 'react'
import './filter.css'
import {Modal} from 'react-bootstrap'
import Thousand from './filters/Thousand'
import Thousandone from './filters/Thousandone';
import Thousandtwo from './filters/Thousandtwo';
import Thousandthree from './filters/Thousandthree';
import Thousandfour from './filters/Thousandfour';
export default class Filter extends Component {
    constructor(props){
        super(props)
        // const storeOldData = (props) => {
        //     var obj = {values:{},def:{}}
        //     for(var i=0;i<this.props.filters.length;i++){
        //         obj.values[this.props.filters[i].filtername] = this.props.filters[i].values
        //         obj.def[this.props.filters[i].filtername] =  this.props.filters[i].defval
        //     }
        //     var arr = []
        //     console.log(arr)
        //     arr.push(obj)
        //     return arr
        // }
        // storeOldData()
        this.state={
            isOpenModal:false,filterData:null,filtername:'',count:0,defaultValue:[],UpdateddefaultValue:[],UnsetdefaultValue:[]
        }
        // this.oldData = storeOldData()
        this.setFilter = this.setFilter.bind(this)
        this.updateDefaultvalues = this.updateDefaultvalues.bind(this)
        this.clearFilters =this.clearFilters.bind(this)
        this.closeFilterModal = this.closeFilterModal.bind(this)
    }
    componentDidMount(){
        var obj = {values:{},def:{},oldvalues:{}}
        console.log(this.props.filters)
        if(this.props.filters != undefined){
            for(var i=0;i<this.props.filters.length;i++){
                obj.values[this.props.filters[i].filtername] = this.props.filters[i].values
                obj.def[this.props.filters[i].filtername] =  this.props.filters[i].defval
                obj.oldvalues[this.props.filters[i].filtername] =  this.props.filters[i].defval
            }
            this.state.defaultValue.push(obj)
            this.state.UpdateddefaultValue.push(obj)
            this.state.UnsetdefaultValue.push(obj)
        }
        if(this.props.filters != null){
            this.props.filters.map((data,index) => {
                if(index == 0){
                    this.setState({filterData:data,filtername:data.filtername})
                }
            })
        }
    }
    clearFilters(e){
        e.preventDefault()
        this.props.clearFilters()
        this.setState({isOpenModal:false})
    }
    setFilter(data){
        this.setState({filterData:data,filtername:data.filtername})
    }
    updateDefaultvalues(data){
        var defaultdata = JSON.parse(JSON.stringify(this.state.UpdateddefaultValue))
        defaultdata[0].def[this.state.filtername] = data
        this.setState({UpdateddefaultValue:defaultdata})
    }
    updateDefaultCheckboxvalues(data,lastchange){
        console.log(data)
        this.setState({lastchange:lastchange})
        console.log(this.state.defaultValue)
        var defaultdata = JSON.parse(JSON.stringify(this.state.UpdateddefaultValue))
        defaultdata[0].def[this.state.filtername] = data
        this.setState({UpdateddefaultValue:defaultdata})
    }
    applyFiltes(e){
        e.preventDefault()
        if(Object.keys(this.state.defaultValue[0].def).length != 0){
            this.setState({isOpenModal:false,defaultValue:this.state.UpdateddefaultValue})
            setTimeout(() => {
                var filterStr = ''
                var keys = Object.keys(this.state.defaultValue[0].def)
                for(var i=0;i<keys.length;i++){
                    if(i<keys.length-1){
                        filterStr += this.state.defaultValue[0].def[keys[i]]+'$#12$$'
                    }else{
                        filterStr += this.state.defaultValue[0].def[keys[i]]
                    }
                }
                console.log(this.state.defaultValue[0].def)
                this.props.applyFiltes(filterStr,this.state.defaultValue[0].def)
            }, 200);
        }
        console.log(this.state.defaultValue)
        console.log('update 3')
    }
    goBack(e){
        e.preventDefault()
        this.props.getCallback(true)
        this.state.defaultValue = []
    }
    closeFilterModal(){
        // for(var i=0;i<this.props.filters.length;i++){
        //     // console.log(this.props.filters[i].defvalues)
            // this.state.defaultValue[0].def[this.props.filters[i].filtername] = this.state.defaultValue[0].oldvalues[this.props.filters[i].filtername]
        //     // console.log(defaultValue[0].def[this.props.filters[i].filtername])
        // }
        
        console.log(this.state.UpdateddefaultValue)
        console.log(this.state.defaultValue)
        this.setState({UpdateddefaultValue:this.state.defaultValue})
        this.props.onClose()
    }
    render() {
        return (
            <>
            {/* <nav className="navbar navbar-light bg-light" style={{marginTop:"20px"}}>
                <div className="justify-content-end ms-3">
                    <IconButton>
                        <ArrowBackIcon onClick={(e) => this.goBack(e)}/>
                    </IconButton>
                    <span style={{fontSize:"23px",fontWeight:"600",paddingLeft:"20px",position:"relative",top:"5px"}}>{this.props.header}</span>
                </div>
                <div className="justify-content-start me-3"> */}
                    {
                        // this.props.filters != null ?
                        // <>
                        //     <IconButton>
                        //         <FilterAltIcon onClick={(e) => this.openFilterModal(e)}/>
                        //     </IconButton>
                        //     <IconButton disabled={this.props.disableexcel}>
                        //         <img src={ExcelIcon} style={{width:"25px",height:"25px"}} onClick={(e) => this.props.downloadFun(this.props.header,e)} />
                        //         {/* <FileDownloadIcon onClick={(e) => this.props.downloadFun(this.props.header,e)}/> */}
                        //     </IconButton>
                        // </>
                        // :null
                    }
                {/* </div>
            </nav> */}
            {/* filter modal start */}
            <Modal size="lg" centered style={{ backgroundColor: 'rgba(0,0,0,0.6)'}} show={this.props.isOpenModal} onHide={() => this.closeFilterModal()}  >
                <Modal.Header>
                    <h3>Filters</h3>
                    <div style={{display:"flex",justifyContent:"space-between",width:"250px"}}>
                        <div className="btn btn-warning" style={{color:"#fff"}} onClick={(e) => this.clearFilters(e)}>Clear Filters</div>
                        <div className="btn btn-info" style={{color:"#fff"}} onClick={(e) => this.applyFiltes(e)}>Apply Filters</div>
                        <div className="" style={{ color: "black",fontSize: 'x-large',cursor: 'pointer' }} onClick={() => this.closeFilterModal()}>&times;</div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-4">
                            <div className='row filternames'>
                                {
                                    this.props.filters != null ?
                                    this.props.filters.map((data,index) => {
                                        return(
                                            <div key={index} className={'col-12'+(data.filtername == this.state.filtername ? " active" : '')} onClick={()=> this.setFilter(data)}>{data.filtername}</div>
                                        )
                                    })
                                    :""
                                }
                            </div>
                        </div>
                        <div className="col-8" style={{maxHeight:"400px",overflow:"hidden"}}>
                            {
                                this.state.filterData != null?
                                this.state.filterData.filtertype == 1000 ?
                                <Thousand defdata={this.state.UpdateddefaultValue[0].def[this.state.filterData.filtername]} onChange={(val) => this.updateDefaultvalues(val)}/>
                                :
                                this.state.filterData.filtertype == 1001 ? 
                                <Thousandone defdata={this.state.UpdateddefaultValue[0].def[this.state.filterData.filtername]} onChange={(val) => this.updateDefaultvalues(val)}/> 
                                :
                                this.state.filterData.filtertype == 1002 ? 
                                <Thousandtwo filterData={this.state.UpdateddefaultValue[0].values[this.state.filterData.filtername]} defdata={this.state.UpdateddefaultValue[0].def[this.state.filterData.filtername]} onChange={(val) => this.updateDefaultvalues(val)}/>
                                :
                                this.state.filterData.filtertype == 1003 ? 
                                <Thousandthree filterData={this.state.UpdateddefaultValue[0].values[this.state.filterData.filtername]} defdata={this.state.UpdateddefaultValue[0].def[this.state.filterData.filtername]} onChange={(val,lastchange) => this.updateDefaultCheckboxvalues(val,lastchange)} lastChange={this.state.lastchange}/>
                                :
                                this.state.filterData.filtertype == 1004 ? 
                                <Thousandfour filterData={this.state.UpdateddefaultValue[0].values[this.state.filterData.filtername]} defdata={this.state.UpdateddefaultValue[0].def[this.state.filterData.filtername]} onChange={(val) => this.updateDefaultvalues(val)}/>
                                :"":""
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* filter modal end */}
            </>
        )
    }
}
